import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { IQuestion } from '@interfaces/questions';
import { NzJustify } from 'ng-zorro-antd/grid';
import { NzFormItemComponent } from 'ng-zorro-antd/form';

@Component({
	selector: 'workflow-questionnaire',
	templateUrl: './questionnaire.component.html',
	styleUrls: ['./questionnaire.component.scss'],
})
export class QuestionnaireComponent extends NzFormItemComponent {

	@Input() question: IQuestion;
	@Input() justify: NzJustify;
	@Input() isWizard = false;
	@Input() finishedAndLocked = false;
	@Input() validationLevel: 'warning' | 'error' = 'error';
	@Input() isLocked = false;
	@Input() isTableDisplay: boolean;

	@Output() valid: EventEmitter<boolean> = new EventEmitter();

	constructor(elementRef: ElementRef, renderer: Renderer2, cdr: ChangeDetectorRef) {
		super(elementRef, renderer, cdr);
	}

	public setValid(valid: boolean): void {
		this.valid.emit(valid);
	}
}
